import { ReactNode } from "react";
import clsx from "clsx";
import './Modal.scss';

export default function Modal({
  isActive,
  onCancel,
  children,
}: {
  isActive: boolean;
  onCancel: () => void;
  children?: ReactNode;
}) {
  return (
    <div className={clsx("modal", { "is-active": isActive })}>
      <div className="modal-background" onClick={onCancel}></div>
      <div className="modal-content">{children}</div>
    </div>
  );
}
